import { useApi } from './useApi';
import { BaseHookRequest, BaseRequest } from './useApi.types';
import {
  LocaleCatalogResponse,
  LocaleTemplateBody,
  LocaleTemplatesQuery,
  LocaleTypesResponse,
} from './useLocaleTemplates.types';

export const useGetLocaleTypes: BaseHookRequest<LocaleTypesResponse, null> = params => {
  const [{ getRequest }, state] = useApi<LocaleTypesResponse>(params);
  const getLocaleTypes = () => getRequest('/admin/localeTemplates');
  return [getLocaleTypes, state];
};

export const useGetLocaleCatalog: BaseHookRequest<
  LocaleCatalogResponse,
  Pick<LocaleTemplatesQuery, 'type'>
> = params => {
  const [{ getRequest }, state] = useApi<LocaleCatalogResponse>(params);
  const getLocaleCatalog: BaseRequest<Pick<LocaleTemplatesQuery, 'type'>> = details => {
    return details?.variables?.type
      ? getRequest('/admin/localeTemplates', { type: details.variables.type })
      : undefined;
  };
  return [getLocaleCatalog, state];
};

export const useGetLocaleTemplate: BaseHookRequest<LocaleTemplateBody, LocaleTemplatesQuery> =
  params => {
    const [{ getRequest }, state] = useApi<LocaleTemplateBody>(params);
    const getLocaleTemplate: BaseRequest<LocaleTemplatesQuery> = details => {
      return details?.variables?.type && details.variables.path
        ? getRequest('/admin/localeTemplates', {
            type: details.variables.type,
            path: details.variables.path,
          })
        : undefined;
    };
    return [getLocaleTemplate, state];
  };
